import { initCustomerDocumentAPI } from '../module/customer-document/customer-document-slice.api';
import { initCatalogueAPI } from '../module/catalogue/catalogue-slice.api';
import { initChatAPI } from '../module/chat/chat-slice.api';
import { initCustomerChatAPI } from '../module/customer-chat/customer-chat-slice.api';
import { initCustomerConfigurationAPI } from '../module/customer-configuration/customer-configuration-slice.api';
import { initCustomerProjectAPI } from '../module/customer-project/customer-project-slice.api';
import { initDocumentAPI } from '../module/document/document-slice.api';
import { initMonitoringAPI } from '../module/monitoring/monitoring-slice.api';
import { initUserAPI } from '../module/user/user-slice.api';
import { initFilesAPI } from '../module/files/files-slice.api';
import { initMainAPI } from '../module/main/main-slice.api';

import { HttpChatGateway } from '../module/chat/http-chat.gateway';
import { HttpCustomerChatGateway } from '../module/customer-chat/http-customer-chat.gateway';
import { HttpCustomerConfigurationGateway } from '../module/customer-configuration/http-customer-configuration.gateway';
import { HttpCustomerProjectGateway } from '../module/customer-project/http-customer-project.gateway';
import { HttpDocumentGateway } from '../module/document/http-document.gateway';
import { HttpMonitoringGateway } from '../module/monitoring/http-monitoring.gateway';
import { HttpUserGateway } from '../module/user/http-user.gateway';
import { HttpFilesGateway } from '../module/files/http-files.gateway';
import { HttpCustomerDocumentGateway } from '../module/customer-document/http-customer-document.gateway';
import { HttpCatalogueGateway } from '../module/catalogue/http-catalogue.gateway';
import { HttpMainGateway } from '../module/main/http-main.gateway';

/**
 * Utile pour les pages de signatures
 */
import { initProjectAPI } from '../module/project/project-slice.api';
import { HttpProjectGateway } from '../module/project/http-project.gateway';
import { initTaskAPI } from '../module/task/task-slice.api';
import { HttpTaskGateway } from '../module/task/http-task.gateway';

/**
 * TODODEV : faire accepter import.meta à Typescrip puis retirer les @ts-ignore ci-dessous
 */
export const useCustomerAreaConfiguration = (apiSlice: any) => {
  // @ts-ignore
  if (import.meta.env.VITE_ENVIRONNEMENT !== 'local') {
    initProjectAPI(apiSlice, new HttpProjectGateway());
    initTaskAPI(apiSlice, new HttpTaskGateway());

    initCatalogueAPI(apiSlice, new HttpCatalogueGateway());
    initCustomerChatAPI(apiSlice, new HttpCustomerChatGateway());
    initCustomerConfigurationAPI(
      apiSlice,
      new HttpCustomerConfigurationGateway()
    );
    initCustomerProjectAPI(apiSlice, new HttpCustomerProjectGateway());
    initCustomerDocumentAPI(apiSlice, new HttpCustomerDocumentGateway());
    initMonitoringAPI(apiSlice, new HttpMonitoringGateway());
    initUserAPI(apiSlice, new HttpUserGateway());
    initFilesAPI(apiSlice, new HttpFilesGateway());
    initMainAPI(apiSlice, new HttpMainGateway());

    // endpoint CRM mais a conserver pour la page CHAT, TODODEV : séparer la logique de cette page pour les 2 applis, sous la forme de 2 composant Feature distinct
    // puis supprimer ces 2 endpoints
    initChatAPI(apiSlice, new HttpChatGateway());
    initDocumentAPI(apiSlice, new HttpDocumentGateway());
  } else {
    // initCompositionSlice(apiSlice, new InMemoryCompositionGateway());
  }
};
